import React, { createContext, useContext, useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { getEmpresa } from "./lib/api";
import Layout from "./components/layout/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Recepcion from "./pages/Recepcion";
import Presupuestos from "./pages/Presupuestos";
import Ordenes from "./pages/Ordenes";
import Repuestos from "./pages/Repuestos";
import Clientes from "./pages/Clientes";
import Tecnicos from "./pages/Tecnicos";
import Proveedores from "./pages/Proveedores";
import Aseguradoras from "./pages/Aseguradoras";
import Facturacion from "./pages/Facturacion";
import Reportes from "./pages/Reportes";
import Sistema from "./pages/Sistema";

export const AuthContext = createContext(null);

export function useAuth() {
  return useContext(AuthContext);
}

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
  });
  const [theme, setTheme] = useState(() => localStorage.getItem("theme") || "light");
  const [empresa, setEmpresa] = useState({ nombre: "", label: "", logo_url: null });
  const [presupuestosReducidos, setPresupuestosReducidos] = useState(0);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  useEffect(() => {
    if (localStorage.getItem("token")) {
      getEmpresa().then((r) => setEmpresa(r.data)).catch(() => {});
    }
  }, [user]);

  const login = (userData, token) => {
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, theme, setTheme, empresa, setEmpresa, presupuestosReducidos, setPresupuestosReducidos }}>
      <BrowserRouter>
        <Toaster richColors position="top-right" />
        <Routes>
          <Route path="/login" element={user ? <Navigate to="/dashboard" replace /> : <Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="recepcion" element={<Recepcion />} />
            <Route path="presupuestos" element={<Presupuestos />} />
            <Route path="ordenes" element={<Ordenes />} />
            <Route path="repuestos" element={<Repuestos />} />
            <Route path="clientes" element={<Clientes />} />
            <Route path="tecnicos" element={<Tecnicos />} />
            <Route path="proveedores" element={<Proveedores />} />
            <Route path="aseguradoras" element={<Aseguradoras />} />
            <Route path="facturacion" element={<Facturacion />} />
            <Route path="reportes" element={<Reportes />} />
            <Route path="sistema" element={<Sistema />} />
          </Route>
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthContext.Provider>
  );
}
